import React from "react";
import { useSetRecoilState } from "recoil";
import AdminNavbar from "../../modules/admin/AdminNavbar";
import Table from "../../modules/layout/Table";
import {
  isPresetAddModalOpenState,
  isPresetModifyModalOpenState,
} from "../../../recoil/admin/examRoom";
import AdminPresetAddModal from "./AdminPresetAddModal";
import AdminPresetModifyModal from "./AdminPresetModifyModal";
import { useQuery } from "@tanstack/react-query";
import usePresetActions from "../../../api/hooks/admin/preset";

const AdminPreset = () => {
  const setIsPresetAddModalOpen = useSetRecoilState(isPresetAddModalOpenState);
  const setIsPresetModifyModalOpen = useSetRecoilState(
    isPresetModifyModalOpenState
  );

  const { fetchPresetList } = usePresetActions();

  const { data: presetList } = useQuery({
    queryKey: ["fetchPresetList"],
    queryFn: () => fetchPresetList(),
    onSuccess: () => {
      console.log(presetList);
    },
  });

  return (
    <>
      <div>
        <link rel="stylesheet" type="text/css" href="/css/admin.css" />
        <link rel="stylesheet" type="text/css" href="/css/koica.css" />
        <AdminNavbar />

        <div className="admin_content">
          <div className="content-title">
            <p className="home">문항 프리셋</p>
          </div>
          <div className="content-cont">
            <div className="container">
              <div className="tab-title">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="home-tab"
                      type="button"
                    >
                      문항 프리셋
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div className="flex filtering" style={{ marginTop: 0 }}>
                    <div>
                      <button
                        type="button"
                        className="btn-custom b-btn plus"
                        onClick={() => setIsPresetAddModalOpen(true)}
                      >
                        프리셋 추가
                      </button>
                    </div>
                    <div>
                      <input
                        type="text"
                        className="search-input"
                        placeholder="프리셋 제목"
                      />
                    </div>
                  </div>
                  <div className="height-modify">
                    <Table
                      className="question-table"
                      header={["프리셋 제목", "시험 유형", "작업"]}
                    >
                      {presetList?.data.map((preset) => (
                        <tr key={preset.sn}>
                          <td>{preset.title}</td>
                          <td>KOICA</td>
                          <td>
                            <button
                              type="button"
                              className="insert-modalbtn"
                              onClick={() => {
                                setIsPresetModifyModalOpen(true);
                              }}
                            ></button>
                            <button className="trashbtn"></button>
                          </td>
                        </tr>
                      ))}
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AdminPresetAddModal />
        <AdminPresetModifyModal />
      </div>
    </>
  );
};

export default AdminPreset;
